// extracted by mini-css-extract-plugin
module.exports = {"loader":"l_f","spinner__circle":"l_L","spinningCircleAnim":"l_M"};